module.exports = __webpack_public_path__ + "logo_47-6bbb381c6f6d70ed9b18c89130425e5f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/leagues/logo_47.png
// module id = 1137
// module chunks = 0 1